import { COMISSION, RESERVE, REVERSAL_OVERINFUSION } from '../../constants/statementTypeCodes'

/**
 * Get sign of money based on type code
 * @param {number} money
 * @param {string} typeCode
 * @returns {number}
 */
const getSignMoney = (money: any, typeCode: string) => {
  switch (typeCode) {
    case RESERVE:
    case COMISSION:
    case REVERSAL_OVERINFUSION:
      return (-1) * money

    default:
      return money
  }
}

export default getSignMoney
